import { useMemo } from 'react';
import { useGoodsDetail } from '../../../queries/useGoodsDetail';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';

export const useDeliveryInfoMessage = (): string => {
  const { data: goodsDetail } = useGoodsDetail();
  const { data: goodsBasic } = useGoodsBasic();

  return useMemo(() => {
    if (goodsDetail?.goods.shipping_info?.formatted_message) {
      return goodsDetail.goods.shipping_info.formatted_message;
    }
    return goodsBasic?.market.is_delivered_by_ably
      ? '에이블리 직접 무료 배송'
      : '마켓 직접 무료 배송';
  }, [goodsDetail, goodsBasic]);
};